/**
 * Copyright (c) Fing Ltd. All rights reserved.
 *
 * @author Tommaso Latini <tommaso@fing.com>
 */

// Object

export function isObject(obj) {
    return obj !== null && typeof obj === "object";
}

export function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object
}

// String

export function capitalizeFirst(str) {
    if (typeof str !== 'string' || str.length === 0)
        return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isNotEmptyString(str, trimmed) {
    if (typeof str !== 'string')
        return false;
    if (trimmed)
        str = str.trim();
    return str.length > 0;
}

export function isNotEmptyArray(array) {
    return Array.isArray(array) && array.length > 0;
}

// Promise

export function executeUntilSuccess(operation, delay) {
    return operation() // run the operation
        .catch((reason) => { // if it fails
            return new Promise((resolve) => setTimeout(resolve, delay)) // delay
                // retry with more time
                .then(executeUntilSuccess.bind(null, operation, delay * 2));
        });
}

// React Form

export function onKeyDown(keyEvent) {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  }

// Mail

/* (for some reasone escaping square brackets is notified as warning) */
/* eslint-disable */
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// https://www.softwaretestinghelp.com/email-service-providers
export const PERSONAL_EMAIL_PROVIDERS = [
    "gmail", "googlemail", 
    "yahoo", 
    "hotmail", "outlook", "msn", 
    "aol", 
    "apple", 
    "comcast", "orange", "mail", "protonmail", "zoho"
];

export function isValidEmail(mail, undesiredProviders) {
    if (isNotEmptyString(mail) && EMAIL_REGEX.test(mail)) {
        // Valid E-Mail
        if (!Array.isArray(undesiredProviders) || undesiredProviders.length == 0)
            return true;
        
        // We need to exclude some providers
        const domain = mail.slice(mail.lastIndexOf('@')+1);
        const provider = domain.slice(0, domain.indexOf('.'));
        return undesiredProviders.indexOf(provider) === -1;
    
    }
    return false;
}

export function getField(obj, field, dflt) {
    if (!isObject(obj))
        return dflt;
    if (!obj.hasOwnProperty(field))
        return dflt;
    return obj[field];
}

export function getFieldOrNull(obj, field) {
    return getField(obj, field, null);
}

export function formatPercentage(val) {
    let res = val.toFixed(1);
    if (res[res.length - 1] === "0") return res.substr(0, res.length - 2) + "%";
    return res + "%";
}

export function isInRange(num, min, max) {
    if (isNaN(num))
        return false;
    return min <= num && num <= max;
}
export function lookupArrayWithProperty(array, property, value) {
    if (!Array.isArray(array))
        return null;
    return array.find(elem => isObject(elem) && elem[property] === value);
}

/**
 * Returns a random number between min (inclusive) and max (exclusive)
 */
export function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}

/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer) and no greater than max (or the next integer
 * lower than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 */
export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}